//#region Libraries
import styled from "styled-components";
//#endregion

const h2 = `
& h2 {
    font-size: 20px;
    color: var(--dark-4);
    margin: 0;
}
`;
const li = `
& li { 
    color: var(--light-gray-5);
    margin: 0;
}
`;
export const Observations = styled.section`
    display: flex;
    flex-direction: column;
    gap: 15px;
    & > header {
        display: flex;
        gap: 10px;
        ${h2}
    }
    ${li}
`;
export const BackToManualLoading = styled.section`
    display: flex;
    flex-direction: column;
    gap: 15px;
    border: 1px solid var(--purple-4);
    border-radius: 8px;
    padding: 24px 32px;
    ${h2}
    ${li}
`;